import {Component, OnInit} from '@angular/core';
import {FormValidator} from '../form.validator';
import {SchoolRegistrationService} from './schoolregistraton.service';
import { BrandService } from '../brand/brand.service';

declare var $: any;
declare var jquery: any;
declare var d3: any;
declare var customToastr: any;
declare var materialadmin: any;

@Component({
  selector: 'app-schoolregistration',
  templateUrl: './schoolregistration.component.html',
  styleUrls: [
    './schoolregistration.component.css'],
  providers: [FormValidator, SchoolRegistrationService]
})
export class SchoolregistrationComponent implements OnInit {

  regform = true;
  emailconfirm = false;
  signinemail = false;
  signinWithEmailData = '';
  resendOtpTrials = 0;

  registerName;
  registerSchoolName;
  registerSchoolCountry;
  registerSchooolEmail;
  registerSchoolContact;
  registerSchoolAreaPinCode;
  registerSchoolUrl;
  registerSchoolUsername;
  registerSchoolPassword;
  registerSchoolVerificationCodeGet;
  registerSchoolDescription;
  registerSchoolState;
  registerSchoolLocality;
  registerSchoolAddress;

  invalidregisterName = false;
  invalidregisterSchoolName = false;
  invalidregisterSchoolCountry = false;
  invalidregisterSchooolEmail = false;
  invalidregisterSchoolContact = false;
  invalidregisterSchoolAreaPinCode = false;
  invalidregisterSchoolUrl = false;
  invalidregisterSchoolUsername = false;
  invalidregisterSchoolPassword = false;
  invalidregisterSchoolState = false;
  invalidregisterSchoolLocality = false;
  invalidregisterSchoolAddress = false;

  invalidregisterSchooolEmail2 = false;
  invalidregisterSchoolUsername2 = false;

  invalidVerificationCode = false;

  invalidSignUpEmail = false;

  regLoader = false;
  brand = this.brandService.brand;

  constructor(private  formValidator: FormValidator, private schoolRegistrationService: SchoolRegistrationService, private brandService: BrandService) {
    // get subdomain name
    const full = window.location.host;
    // window.location.host is subdomain.domain.com
    const parts = full.split('.');
    const sub = parts[0];
    const domain = parts[1];
    const type = parts[2];
    if (sub === 'edu') {
      this.signinWithEmail();
    }
  }


  signinWithEmail() {
    this.regform = false;
    this.emailconfirm = false;
    this.signinemail = true;
  }

  signInEmail() {
    this.invalidSignUpEmail = false;

    this.regLoader = true;
    const getEmail = this.signinWithEmailData;
    this.schoolRegistrationService.getSchoolWithEmail(getEmail)
      .subscribe(
        (data: any) => {
          this.regLoader = false;
          if (data.SchoolDomain !== undefined) {
            const getDomain = data.SchoolDomain;
            const domainSuffix = this.brand.domainSuffix || window.location.hostname.split(".").slice(1).join(".");
            location.href = 'http://' + getDomain + '.' + domainSuffix;
          } else {
            this.invalidSignUpEmail = true;
          }
        },
        error =>
          () => {
          }
      );
  }


  proceedRegister() {

    this.invalidregisterName = false;
    this.invalidregisterSchoolName = false;
    this.invalidregisterSchoolCountry = false;
    this.invalidregisterSchooolEmail = false;
    this.invalidregisterSchoolContact = false;
    this.invalidregisterSchoolAreaPinCode = false;
    this.invalidregisterSchoolUrl = false;
    this.invalidregisterSchoolUsername = false;
    this.invalidregisterSchoolPassword = false;
    this.invalidregisterSchoolState = false;
    this.invalidregisterSchoolLocality = false;
    this.invalidregisterSchoolAddress = false;

    this.invalidregisterSchoolUsername2 = false;
    this.invalidregisterSchooolEmail2 = false;

    if (!this.formValidator.validateIsData(this.registerName) || $.isNumeric(this.registerName)) {
      this.invalidregisterName = true;
    } else if (!this.formValidator.validateIsData(this.registerSchoolName) || $.isNumeric(this.registerSchoolName)) {
      this.invalidregisterSchoolName = true;
    } else if (!this.formValidator.validateIsData(this.registerSchooolEmail)) {
      this.invalidregisterSchooolEmail = true;
    } else if (!this.formValidator.validateIsEmail(this.registerSchooolEmail)) {
      this.invalidregisterSchooolEmail = true;
    } else if (!this.formValidator.validateIsData(this.registerSchoolContact)) {
      this.invalidregisterSchoolContact = true;
    } else if (!this.formValidator.validateMobileNumber(this.registerSchoolContact)) {
      this.invalidregisterSchoolContact = true;
    } else if (!this.formValidator.validateIsData(this.registerSchoolCountry)) {
      this.invalidregisterSchoolCountry = true;
    } else if (!this.formValidator.validateIsData(this.registerSchoolState)) {
      this.invalidregisterSchoolState = true;
    } else if (!this.formValidator.validateIsData(this.registerSchoolLocality)) {
      this.invalidregisterSchoolLocality = true;
    } else if (!this.formValidator.validateIsData(this.registerSchoolAddress)) {
      this.invalidregisterSchoolAddress = true;
    } else if (!this.formValidator.validateIsData(this.registerSchoolAreaPinCode)) {
      this.invalidregisterSchoolAreaPinCode = true;
    } else if (!$.isNumeric(this.registerSchoolAreaPinCode)) {
      this.invalidregisterSchoolAreaPinCode = true;
    } else if (!this.formValidator.validateIsData(this.registerSchoolUrl)) {
      this.invalidregisterSchoolUrl = true;
    } else if (this.registerSchoolUrl.length < 3) {
      this.invalidregisterSchoolUrl = true;
    } else if (/[-!$%^&*()_+|~=`{}\[\]:";'<>?,. \/]/.test(this.registerSchoolUrl)) {
      this.invalidregisterSchoolUrl = true;
    } else if (!this.formValidator.validateIsData(this.registerSchoolUsername)) {
      this.invalidregisterSchoolUsername = true;
    } else if (/[-!$%^&*()_+|~=`{}\[\]:";'<>?,. \/]/.test(this.registerSchoolUsername)) {
      this.invalidregisterSchoolUsername = true;
    } else if (this.registerSchoolUsername.length < 3) {
      this.invalidregisterSchoolUsername = true;
    } else if (!this.formValidator.validateIsData(this.registerSchoolPassword)) {
      this.invalidregisterSchoolPassword = true;
    } else if (this.registerSchoolPassword.length < 6) {
      this.invalidregisterSchoolPassword = true;
    } else {

      this.regLoader = true;

      // check the school url is valid
      this.schoolRegistrationService.isExcitingUrl(this.registerSchoolUrl)
        .subscribe(
          (data: any) => {
            if (data.isDomainExist === false) {
              // Start send verification code to email address
              this.schoolRegistrationService.sendVerificationCode(this.registerSchoolUrl, this.registerSchooolEmail,
              this.registerSchoolUsername, this.registerSchoolContact)
                .subscribe(
                  (dataResponse: any) => {
                    this.regLoader = false;
                    if (dataResponse.status !== false) {
                      this.regform = false;
                      this.emailconfirm = true;
                      this.signinemail = false;
                      this.resendOtpTrials = 0;
                    } else {
                      this.regLoader = false;
                      if (dataResponse.username !== undefined) {
                        this.invalidregisterSchoolUsername2 = true;
                      }
                      if (dataResponse.emailId !== undefined) {
                        this.invalidregisterSchooolEmail2 = true;
                      }
                    }
                  },
                  error => {
                  }
                );
              // End send verification code service
            } else {
              this.regLoader = false;
              this.invalidregisterSchoolUrl = true;
            }
          },
          error => {

          }
        );
    }
  }

  // register school with email verification code
  registerSchool() {
    this.resendOtpTrials++;
    this.regLoader = true;
    this.invalidVerificationCode = false;

    const yourname = this.registerName;
    const phoneNumber = this.registerSchoolContact;

    const domainName = this.registerSchoolUrl;
    const schoolName = this.registerSchoolName;
    const description = this.registerSchoolDescription;
    const state = this.registerSchoolState;
    const locality = this.registerSchoolLocality;
    const pincode = this.registerSchoolAreaPinCode;
    const address = this.registerSchoolAddress;
    const accountType = 'Trial';
    const emailId = this.registerSchooolEmail;
    const password = this.registerSchoolPassword;
    const username = this.registerSchoolUsername;
    const emailVerificationCode = this.registerSchoolVerificationCodeGet;
    const country = this.registerSchoolCountry;

    this.schoolRegistrationService.registerSchool(domainName, schoolName, description, state, locality,
      pincode, address, accountType, emailId, password, username, yourname, phoneNumber, emailVerificationCode, country)
      .subscribe(
        (data: any) => {
          this.regLoader = false;
          if (data.errorcode === undefined && data.status === true) {
            // go to login page ==> to subdomain of school
            const domainSuffix = this.brand.domainSuffix || window.location.hostname.split(".").slice(1).join(".");
            location.href = 'http://' + domainName + '.' + domainSuffix;
          } else {
            this.invalidVerificationCode = true;
          }
        },
        error => {
        }
      );
  }

  // resend verification code
  resendVerificationCode() {
    this.regLoader = true;
    this.resendOtpTrials++;
    this.schoolRegistrationService.sendVerificationCode(this.registerSchoolUrl, this.registerSchooolEmail,
      this.registerSchoolUsername, this.registerSchoolContact)
      .subscribe(
        (data: any) => {
          if (data.status !== false) {
            this.regform = false;
            this.emailconfirm = true;
            this.signinemail = false;
            this.regLoader = false;
          } else {
            this.regLoader = false;
          }
        },
        error => {
        }
      );
  }

  ngOnInit() {
    $('.after').empty();
    $('.after').append('<script>function customToastr(message,type,title){toastr.options.hideDuration = 0;toastr.clear();' +
      'toastr.options.closeButton = true;toastr.options.progressBar = false;toastr.options.debug = false;' +
      'toastr.options.positionClass = \'toast-top-right\';toastr.options.showDuration = 330;' +
      'toastr.options.hideDuration = 330;toastr.options.timeOut = 5000;toastr.options.extendedTimeOut = 1000;' +
      'toastr.options.showEasing = \'swing\';toastr.options.hideEasing = \'swing\';toastr.options.showMethod = \'slideDown\';' +
      'toastr.options.hideMethod = \'slideUp\';toastr[type](message, title || \'\');return 0;}	</' + 'script>');
  }
}
